import script from "./LicenseInactiveView.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseInactiveView.vue?vue&type=script&setup=true&lang=js"

import "./LicenseInactiveView.vue?vue&type=style&index=0&id=55059bc1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55059bc1"]])

export default __exports__